import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import shallow from 'zustand/shallow';
import useAuthStore from 'store/auth';
import AppLoading from 'components/AppLoading';
import AuthRouter from 'router/AuthRouter';
import { Main } from 'components';
import { TraderProvider } from 'context/TraderTypeContext';
import {
  LIMITED_MODE_DEFAULT_ROUTE,
  LIMITED_MODE_ENABLED
} from 'config/limitedMode';

const AUTH_PATHS = ['/', '/sign-in'];

function App() {
  const history = useHistory();
  const location = useLocation();
  const [isLoggedIn, isLoading, getUser, isError, signOut, resetInactivityTimer] = useAuthStore(
    (state) => [
      state.isLoggedIn,
      state.isLoading,
      state.getUser,
      state.isError,
      state.signOut,
      state.resetInactivityTimer,
    ],
    shallow
  );

  useEffect(() => {
    if (isLoggedIn) getUser();
  }, [getUser, isLoggedIn]);

  useEffect(() => {
    if (!isLoggedIn || isLoading) return;

    if (AUTH_PATHS.includes(location.pathname)) {
      history.replace(
        LIMITED_MODE_ENABLED ? LIMITED_MODE_DEFAULT_ROUTE : '/product'
      );
    }
  }, [history, isLoggedIn, isLoading, location.pathname]);

  useEffect(() => {
    if (isError && isLoggedIn) signOut();
  }, [isError, isLoggedIn, signOut]);

  useEffect(() => {
    console.log("Ver: ", process.env.REACT_APP_VERSION )
    if (!isLoggedIn) return;

    const events = ['mousedown', 'keypress', 'scroll', 'touchstart'];
    const handleActivity = () => resetInactivityTimer();

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        const lastActivityTime = localStorage.getItem('lastActivityTime');
        if (!lastActivityTime) return;

        const elapsed = Date.now() - parseInt(lastActivityTime, 10);
        if (elapsed >= 30 * 60 * 1000) {
          signOut();
        } else {
          resetInactivityTimer();
        }
      }
    };

    events.forEach((event) => window.addEventListener(event, handleActivity));
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      events.forEach((event) => window.removeEventListener(event, handleActivity));
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isLoggedIn, signOut, resetInactivityTimer]);

  if (isLoggedIn && isLoading) {
    return <AppLoading />;
  }

  if (isLoggedIn) {
    return (
      <TraderProvider>
        <Main />
      </TraderProvider>
    );
  }

  return <AuthRouter />;
}

export default App;